var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"novalidate":""},on:{"submit":_vm.submit}},[_vm._t("default",null,null,{ $v: _vm.$v.form, controls: _vm.form, formData: _vm.formData })],2)}
var staticRenderFns = []

export { render, staticRenderFns }